import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MetaService } from '@app/core/services/meta.service';
import { NavItem } from '@app/interfaces/nav-item';
import { NavComponent } from '@app/layout/nav/nav.component';

@Component({
  selector: 'app-faq-page',
  templateUrl: './faq.page.html',
  styleUrls: ['./faq.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NavComponent],
})
export class FaqPage implements OnInit {
  constructor(private metaService: MetaService) {}

  protected navItems: NavItem[] = [{ label: 'FAQ' }];

  ngOnInit(): void {
    const metadata = {
      title: 'ImageBase.pro FAQ – Answers to Common Questions',
      description:
        'Find answers to frequently asked questions about ImageBase.pro, including licensing, usage rights, and how to download high-quality stock images.',
      keywords:
        'ImageBase.pro FAQ, stock images help, licensing information, image usage rights, stock photography questions, download guide',
    };

    this.metaService.setMetadata(metadata);
  }
}
